module.exports = __webpack_public_path__ + "static/fcra-2019-20-q4-e83ca1bce61ceb7e3c303da540b08610.pdf";